AuthRoute = require 'mixins/authenticated-route'

App.StaticPagesRoute = Em.Route.extend AuthRoute,
  model: (params) ->
    # Хак чтобы список обновлялся если добавится или удалится акция
    @store.filter('static-page', params, -> true)

  actions:
    goBackToStaticPagesList: ->
      @transitionTo 'static-pages'
      false
